<template>
  <v-card class="mt-6">
    <v-card-title>
      Check-in e Check-out
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-text-field
            :value="config.checkin"
            type="time"
            outlined
            label="Horário Check-in"
            @input="updateField('checkin', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.checkout"
            type="time"
            outlined
            label="Horário Check-out"
            @input="updateField('checkout', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CheckInOutSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
